import Logo from './Logo';
import { useLang } from '@/context/LanguageContext';
import { scrollToId } from './LenisScroll';

const LINKS = [
  { id: 'how', key: 'how' },
  { id: 'rates', key: 'rates' },
  { id: 'apply', key: 'apply' },
  { id: 'faq', key: 'faq' },
];

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 bg-ink" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1.6fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">{t.footer.tagline}</p>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-pulse">{t.footer.made}</p>
          </div>

          <div>
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-slate-500">
              {t.footer.linksTitle}
            </p>
            <div className="mt-4 flex flex-col items-start gap-2.5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => (window.location.pathname !== '/' ? window.location.assign(`/#${l.id}`) : scrollToId(l.id))}
                  className="text-sm font-semibold text-slate-300 transition-colors hover:text-pulse"
                >
                  {t.nav[l.key]}
                </button>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-slate-500">
              {t.footer.contactTitle}
            </p>
            <div className="mt-4 flex flex-col gap-2.5 text-sm">
              <a
                data-testid="footer-contact-email"
                href="mailto:support@paydayindia.com"
                className="font-semibold text-slate-300 transition-colors hover:text-pulse"
              >
                support@paydayindia.com
              </a>
              <span className="text-slate-500">paydayindia.com</span>
            </div>
          </div>

          <div>
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-slate-500">
              {t.footer.legalTitle}
            </p>
            <div className="mt-4 space-y-3">
              {t.footer.legal.map((p, i) => (
                <p key={i} className="text-[11px] leading-relaxed text-slate-600" data-testid={`footer-legal-${i}`}>
                  {p}
                </p>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-16 select-none text-center font-display text-[13vw] font-black leading-none tracking-tight text-outline lg:text-[10rem]" data-testid="footer-wordmark">
          PAYDAY
        </p>

        <div className="mt-4 border-t border-white/10 pt-6 text-center">
          <p className="text-xs text-slate-600" data-testid="footer-rights">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
